import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import StoriesLanding from "../views/StoriesLanding"

export default function Stories() {

  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <StoriesLanding />
    }

    return null;
  }

  useEffect(() => {
    init();
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

  return view;
}
